// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"983":"15eb11e1","2473":"9b099230","3251":"6a07af73","4845":"6a07af73","5929":"2fa00d5d"}[chunkId] + ".css";
};